import http from "../http-common";

class ComplainDataService {
  getAll(payload) {
    const { filter } = payload;
    const keyword =
      filter?.search === "" || filter?.search === undefined
        ? ""
        : `?keyword=${filter?.search}`;
    return http.get(`/api/v1/backoffice/complain/backoffice/list${keyword}`);
  }
}

export default new ComplainDataService();
